import axios from "~/plugins/axios";

export default {
  getByMortgageId(mortgageId) {
    return axios.get(`/web_api/v1/mortgage_progress_summary/by_mortgage/${mortgageId}`)
      .then((response) => response.data);
  },
};
